var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "v-height-flag" },
    [
      _c("el-card", { staticClass: "pl10" }, [
        _c(
          "div",
          { staticClass: "v-height-flag" },
          [
            _c("div", { staticClass: "alert" }, [
              _c("div", [
                _vm._v("部分员工档案信息还未完善，请 "),
                _c("span", { staticClass: "look" }, [_vm._v("点击查看")]),
              ]),
            ]),
            _vm._v(" "),
            _c("formBox"),
            _vm._v(" "),
            _c("Table"),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }